import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAppointClients, makeInvoice, invoicesSelector } from 'slices/invoiceSlice';
import { Controller, useForm } from 'react-hook-form';
import moment from 'moment';
import { Select } from 'components/common/Select';
import ErrorMessage from 'components/common/ErrorMessage';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { fetchTypes } from 'slices/typeSlice';
import ClientInvoiceViewList from './ClientViewList';
import { fetchAppointClientsListPage } from 'slices/invoiceSlice';
import { fetchGeneratedInvoices } from 'slices/invoiceSlice';
// import { makeMultipleInvoice } from 'slices/invoiceSlice';
import { makeMultipleInvoiceBatch } from 'slices/invoiceSlice';
import Api from 'services/api';
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const InvoicePayments = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { appointClientsListPage, appointClients, generatedInvoices } = useSelector(invoicesSelector);
    const startDateRef = React.useRef(null);
    const endDateRef = React.useRef(null);
    const [clientState, setClientState] = useState([]);
    const [isCreatingInvoice, setIsCreatingInvoice] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [attachmentFormat, setAttachmentFormat] = useState('pdf');
    const toggleModal = () => setModalOpen(!modalOpen);
    const navigate = useNavigate();

    const defaultValues = {
        invoicing_period: "",
        start_date: "",
        end_date: "",
        client_ids: [],
    };

    const [filters, setFilters] = useState({
        invoicing_period: "",
        start_date: "",
        end_date: "",
        client_ids: [],
    });

    const { clearErrors, handleSubmit, watch, formState: { errors }, control, setValue, reset, getValues } = useForm({
        defaultValues: defaultValues
    });

    useEffect(() => {
        setValue("client_ids", []);
    }, []);

    const filteredAccountsLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchTypes(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));

        return {
            options: result.data.map((item) => ({
                value: item.id,
                label: item.name,
            })),
            hasMore: page !== result?.last_page,
            additional: { page: page + 1 },
        };
    };

    const handleResetFields = () => {
        reset(defaultValues);
        setFilters(defaultValues);
        setClientState([]);
        setSearchTerm("");
        dispatch(fetchAppointClientsListPage(1, defaultValues));
    };

    const onSubmit = (data) => {
        setFilters(data);
        setSearchTerm("");
        dispatch(fetchAppointClientsListPage(1, data));
    };

    // const { appointClientsListPage, appointClients, generatedInvoices } = useSelector(invoicesSelector);
    // const handleCreateInvoice = async (invoiceType) => {
    //     // setIsCreatingInvoice(true);
    //     // let invoiceCounter = 1;

    //     if (!Array.isArray(appointClientsListPage) || appointClientsListPage.length === 0) {
    //         toast.error("No clients found to generate the invoice(s). Please adjust your filters and try again.");
    //         return;
    //     }

    //     setIsCreatingInvoice(true);

    //     let invoiceCounter = 1;
    //     try {
    //         const response = await Api.getLastInvoiceNumber();
    //         console.log('response', response);
    //         if (response?.data?.data?.next_invoice_number) {
    //             const lastNum = parseInt(
    //                 response.data.data.next_invoice_number.replace('INV-', '')
    //             );
    //             invoiceCounter = lastNum;
    //         }
    //     } catch (err) {
    //         console.error('Failed to fetch last invoice number:', err);
    //     }

    //     for (const client of appointClientsListPage) {
    //         console.log('invoiceCounter invoiceCounter', invoiceCounter);
    //         console.log(`Processing client ${client.id}...`);
    //         await dispatch(fetchAppointClients(1, { client_ids: [client.id] }, true));

    //         // Add a small delay to ensure state is updated
    //         await new Promise(r => setTimeout(r, 500));

    //         const fullClient = appointClients[0];
    //         if (!fullClient) {
    //             console.log(`No client data for ${client.id}, skipping...`);
    //             continue;
    //         }

    //         const newInvoiceNumber = `INV-${String(invoiceCounter).padStart(3, '0')}`;
    //         invoiceCounter++;

    //         const totalAppt = fullClient.appointments?.length || 0;
    //         const totalDueBill = fullClient?.appointments?.reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0).toFixed(2);

    //         console.log(`Creating invoice for client ${client.id}: ${newInvoiceNumber}, appointments: ${totalAppt}, bill: ${totalDueBill}`);

    //         const invoiceData = {
    //             client_id: client.id,
    //             invoice_number: newInvoiceNumber,
    //             total_appointments: totalAppt,
    //             total_due_bill: totalDueBill,
    //             invoice_type: invoiceType,
    //         };

    //         await new Promise((resolve) => {
    //             dispatch(makeMultipleInvoice(invoiceData, (status, message, pdf, invoice) => {
    //                 console.log(`Invoice creation status for ${client.id}: ${status}`);
    //                 console.log('Invoice object:', invoice);
    //                 if (status) {
    //                     if (pdf) {
    //                         const link = document.createElement('a');
    //                         link.href = `data:application/pdf;base64,${pdf}`;
    //                         link.download = `${newInvoiceNumber}.pdf`;
    //                         link.click();
    //                     }
    //                     // Email sent from backend automatically
    //                     console.log('Invoice created and email sent from backend');
    //                 }
    //                 resolve();
    //             }));
    //         });
    //     }
    //     console.log('All invoices processed');
    //     dispatch(fetchAppointClientsListPage(1, filters));
    //     dispatch(fetchGeneratedInvoices());
    //     setIsCreatingInvoice(false);

    //     toast.success('Invoices created successfully');
    //     navigate('/invoices');
    // };

    const handleCreateInvoice = async (invoiceType) => {
        if (!Array.isArray(appointClientsListPage) || appointClientsListPage.length === 0) {
            toast.error("No clients found to generate the invoice(s). Please adjust your filters and try again.");
            return;
        }

        setIsCreatingInvoice(true);

        try {
            // const clientsData = appointClientsListPage.map((client) => ({
            //     client_id: client.id,
            //     total_appointments: client.total_appointments || 0,
            //     total_due_bill: parseFloat(client.total_due_bill || 0).toFixed(2),
            // }));

            const clientsData = appointClientsListPage.map((client) => {
                const totalAppointments = client?.appointments?.length || 0;
                const totalDueBill = client?.appointments
                    ?.reduce((sum, i) => sum + (i?.invoice?.total_amount || 0), 0)
                    .toFixed(2);
                const appointmentIds = client?.appointments?.map(a => a.id) || [];

                return {
                    client_id: client.id,
                    total_appointments: totalAppointments,
                    total_due_bill: parseFloat(totalDueBill),
                    appointment_ids: appointmentIds,
                    translation_invoice_ids: client?.special_project?.map(project => project.id) || [],
                    start_date: filters.start_date,
                    end_date: filters.end_date,
                };
            });

            await dispatch(makeMultipleInvoiceBatch({ clients: clientsData, invoice_type: invoiceType, attachment_format: attachmentFormat }, (status, message) => {
                if (status) {
                    toast.success(message || 'Invoices are being generated. You will receive emails shortly.');
                    navigate('/invoices');
                } else {
                    toast.error(message || 'Something went wrong.');
                }
            }));
        } catch (err) {
            toast.error('Failed to queue invoices.');
        }

        setIsCreatingInvoice(false);
    };

    const invoiceOption = [
        { label: t("billing.weekly"), value: "weekly" },
        { label: t("billing.biWeekly"), value: "bi-weekly" },
        { label: t("billing.monthly"), value: "monthly" }
    ];




    return (
        <div className="content" style={{}}>
            <div className="row_main_head">
                <h2 className={`main_heading`}>{t("sidebar.billing")}</h2>
            </div>
            <div className="card_table">
                <form className="invoicing_form">
                    <div className='billings  row_Invoice'>
                        <div className="row-primary">
                            <h2>{t("billing.invoicingPeriod")}</h2>
                            <Controller
                                name="invoicing_period"
                                control={control}
                                render={({ field }) => (
                                    <div className='select_box' style={{ width: "100%" }}>
                                        <Select
                                            name="invoicing_period"
                                            options={invoiceOption}
                                            value={invoiceOption.find(opt => opt.value === field.value) || ""}
                                            onChange={(value) => {
                                                field.onChange(value);
                                            }}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                        <div className="row-primary">
                            <h2>{t("billing.startDate")}</h2>
                            <Controller
                                name="start_date"
                                control={control}
                                render={({ field }) => (
                                    <div className="input-image">
                                        <input ref={startDateRef} id='start_date' type="date" name='start_date' placeholder='Start Date' required
                                            {...field}
                                            value={field.value}
                                            onChange={(e) => field.onChange(moment(e.target.value).format("YYYY-MM-DD"))}
                                        />
                                        <img src="/images/celender.png" alt="calendar Icon" className="custom-icon" />
                                    </div>
                                )} />
                        </div>
                        <div className="row-primary">
                            <h2>{t("billing.endDate")}</h2>
                            <Controller
                                name="end_date"
                                control={control}
                                render={({ field }) => (
                                    <div className="input-image ">
                                        <input ref={endDateRef} type="date" name='end_date' placeholder='End Date' required
                                            {...field}
                                            value={field.value}
                                            onChange={(e) => field.onChange(moment(e.target.value).format("YYYY-MM-DD"))}
                                        />
                                        <img src="/images/celender.png" alt="calendar Icon" className="custom-icon" />
                                    </div>
                                )} />
                        </div>
                        <div className="row-primary">
                            <h2>{t("billing.client")}</h2>
                            <Controller
                                name="client_ids"
                                control={control}
                                render={({ field }) => (
                                    <div style={{ width: "100%" }}>
                                        <AsyncPaginate
                                            menuPlacement='auto'
                                            isMulti
                                            styles={{
                                                ...selectCustomStyles,
                                            }}
                                            value={clientState || []}
                                            loadOptions={filteredAccountsLoadOptions}
                                            isClearable
                                            escapeClearsValue
                                            onChange={(obj) => {
                                                setClientState(obj);
                                                field.onChange(obj.map((opt) => opt.value));
                                            }}
                                            additional={{
                                                page: 1,
                                            }}
                                        />
                                        {
                                            errors?.client_ids?.message &&
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.client_ids?.message} />
                                            </div>
                                        }
                                    </div>
                                )}
                            />
                        </div>
                    </div>

                    <div className="row-primary btns_area row_10 mb-0 justify-content-between">
                        <div>
                            <SubmitButton handleSubmit={handleSubmit(onSubmit)} btnText={t("billing.search")} className={'green me-2'} />
                            <SubmitButton buttonType="button" className={'lightBlue'} btnText={t("billing.reset")} handleSubmit={handleResetFields} />
                        </div>

                        <div>
                            <SubmitButton buttonType="button" className={'main'} btnText={t("billing.generateInvoices")} handleSubmit={toggleModal} />
                        </div>
                    </div>
                </form>

                <Modal isOpen={modalOpen} toggle={toggleModal} centered>
                    <ModalBody>
                        <div className='conform_btn_area' style={{ flexDirection: "column" }}>
                            {/* <div className='row-primary'>
                                <h2>Attachment format</h2>
                                <select
                                    className="form-select"
                                    value={attachmentFormat}
                                    onChange={(e) => setAttachmentFormat(e.target.value)}
                                >
                                    <option value="pdf">PDF</option>
                                    <option value="excel">Excel</option>
                                </select>
                            </div> */}
                            <div className='row-primary w-100'>
                                <h2>Attachment format</h2>
                                <div style={{ width: '100%' }}>
                                    <Select
                                        styles={selectCustomStyles}
                                        options={[{ label: 'PDF', value: 'pdf' }, { label: 'Excel', value: 'excel' }]}
                                        value={[{ label: 'PDF', value: 'pdf' }, { label: 'Excel', value: 'excel' }].find(opt => opt.value === attachmentFormat) || null}
                                        isClearable={false}
                                        disabledSearch={true}
                                        onChange={(selected) => setAttachmentFormat(selected ? selected : '')}
                                    />
                                </div>
                            </div>
                            <div className='conform_btn_area'>
                            <button className="main_button text-nowrap" onClick={() => { handleCreateInvoice('detailed'); toggleModal(); }}>{t("billing.detailedInvoice")}</button>
                            <button className="main_button text-nowrap" onClick={() => { handleCreateInvoice('compressed'); toggleModal(); }}>{t("billing.compressedInvoice")}</button>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="table_delete" onClick={toggleModal}>{t("billing.cancel")}</button>
                    </ModalFooter>
                </Modal>

                <ClientInvoiceViewList filters={filters} isCreatingInvoice={isCreatingInvoice} searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
            </div>
        </div>
    );
}

export default InvoicePayments